const fr = {
  10000001: 'SuperEx Célébration 2e Anniversaire',
  10000002: 'Connectez-vous pour des récompenses incroyables!',
  10000003: 'Selon le nombre de participants, plus le nombre de participants est élevé, plus la cagnotte sera débloquée, jusqu\'à 10 000 USDT',
  10000004: 'Célébration du 2e anniversaire de SuperEx',
  10000005: 'Gagnez 20 000 USDT dans un concours de trading de contrats à terme',
  10000006: `Compétition de classement du volume de transactions : Débloquez la plus haute récompense de <span style="color: #ffc72b;">10,000</span> USDT dans la cagnotte bonus`,
  10000007: 'Championnat à terme',
  10000008: 'Gagnez 20 000 USDT dans un concours de trading de contrats à terme',
}
export default fr



// WEBPACK FOOTER //
// ./src/i18n/langs/languageGaea/fr.js